import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { uploadUrl } from './uploadUrl';
const Designideada = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [categories,setCategories]=useState([]);

  const [handleedit,seteditData]=useState({
    id:null,
    title:'',
    media:'',
    description:''
  })

  const [showeditmodal,setshoweditmodal]=useState(false); 

  const [formData, setFormData] = useState({
   title:'',
    media:'',
    description:''

  });
  

  const fetchcategories=async()=>{
    try{
     const res=await axios.get('https://api.squareandangle.pranatigroup.in/api/admin/designidea');
     console.log(res.data);
     setCategories(res.data);
    }catch(e){
      setError(e.response?.data?.message || 'Save failed');
    }
  }
  
  useEffect(() => {
   fetchcategories();
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleOpenModal = () => {
    setFormData({ title: '', media: '', description: '' });
    setShowModal(true);
    setError('');
  };
  const handlesave = async () => {
    setLoading(true);
    setError('');
    try {
      const data=new FormData();
      data.append('title',formData.title);
      data.append('media',formData.media);
      data.append('description',formData.description);
       await axios.post('https://api.squareandangle.pranatigroup.in/api/admin/designidea',data,{
      headers:{
        "Content-Type":"multipart/form-data"
      }
      });
      setShowModal(false);
      setFormData({ title: '',  media: '', description: '' });
      fetchcategories();
    } catch (e) {
      setError(e.response?.data?.message || 'Save failed');
    } finally {
      setLoading(false);
    }
  };


   const handleeditin=(item)=>{
    seteditData({
      id:item.id,
      title:item.title,
    media:item.image,
    description:item.description
    })
    setshoweditmodal(true);
   }
 
   const handledelete=async(id)=>{
     setLoading(true);
    try{
         await axios.delete(`https://api.squareandangle.pranatigroup.in/api/admin/designidea/${id}`);
      fetchcategories();
    }catch(e){
        setError(e.response?.data?.message || 'Save failed');
    }finally{
      setLoading(false);
    }
   }


   const handleupdatecat=async()=>{
     setLoading(true);
     setError('');
    try{

       const data=new FormData();
      data.append('title',handleedit.title);
      data.append('media',handleedit.media);
      data.append('description',handleedit.description);
       await axios.put(`https://api.squareandangle.pranatigroup.in/api/admin/designidea/${handleedit.id}`,data,{
        headers:{"Content-Type":"multipart/form-data"}
      }
      
      );
      fetchcategories();
      setshoweditmodal(false);
      setLoading(false);
    }catch(e){
      setError(e.response?.data?.message || 'Update failed');
      setLoading(false);
      setshoweditmodal(false);
    }
   }

  const stylesD = {
    width: "169%",
    paddingRight: "1102px",
    paddingLeft: "15px",
    marginRight: "auto",
    marginLeft: "auto"
  };
  return (
    <>
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="container-fluid" style={isMobile ? {} : stylesD}>
        <div className="d-flex justify-content-between align-items-center mb-3 px-2 w-100">
          <h3 className="m-0">Design Ideas</h3>
          <button className="btn btn-primary" onClick={handleOpenModal}>+ Add New</button>
        </div>
        <div className="table-responsive w-100 p-0">
          <table className="table table-bordered table-striped bg-white w-100 m-0">
            <thead className="thead-dark">
              <tr>
                <th>Serial No</th>
                <th>Title</th>
                <th>Image</th>
                <th>Description</th>
                
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
            
                {
                categories.length>0 ?(
                
                categories.map((item, index) => (
                <tr key={item.id}>
               
                  <td>{index +1}</td>
                  <td>{item.title}</td>
                   <td><img src={uploadUrl(item.image)} alt="pranati website" width="100"/></td>
                   <td>{item.description}</td>
                  
                  <td className="text-center">
                    <button className="btn btn-sm btn-outline-primary mr-2" onClick={()=>handleeditin(item)}>Edit</button>
                    <button className="btn btn-sm btn-outline-danger" onClick={()=>handledelete(item.id)}>Delete</button>
                  </td>
                </tr>
              ))
                ):(
               <tr>

                <td colSpan="5" className="text-center text-muted">
                  No Design Ideas Found
                </td>
               </tr>

                )}
            </tbody>

            
           
          </table>
        </div>
      </div>
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Category</h5>
                <button 
                  className="close" 
                  style={{ background: 'transparent', border: 'none', fontSize: '1.5rem' }} 
                  onClick={() => setShowModal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
               
                 <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="title"
                  value={formData.title} 
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                />
                <input 
                  type="file"
                  className="form-control mb-2"
                  placeholder="Filename"
                  onChange={(e) => setFormData({ ...formData, media: e.target.files[0] })}
                />
                <textarea
                  className="form-control mb-2"
                  placeholder="description"
                  value={formData.description} 
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                />
               
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handlesave} disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}



      {showeditmodal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Category</h5>
                <button 
                  className="close" 
                  style={{ background: 'transparent', border: 'none', fontSize: '1.5rem' }} 
                  onClick={() => setshoweditmodal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
               
                 <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="text"
                  value={handleedit.title} 
                  onChange={(e) => seteditData({ ...handleedit, title: e.target.value })}
                />
                <input 
                  type="file"
                  className="form-control mb-2"
                  placeholder="Filename"
                  onChange={(e) => seteditData({ ...handleedit, media: e.target.files[0] })}
                />
                <textarea 
                  className="form-control mb-2"
                  placeholder="description"
                  value={handleedit.description} 
                  onChange={(e) => seteditData({ ...handleedit, description: e.target.value })}
                />
                
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setshoweditmodal(false)}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handleupdatecat} disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default Designideada;